export default "__VITE_ASSET__46772526__"